import { useState, useEffect } from "react";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Dialog, DialogTitle, DialogContent, Snackbar, Alert, Switch, Tooltip } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../components/TableComponent";
import TablePaginationComponent from "../../components/TablePagination";
import { Add, Close } from "@mui/icons-material";
import axios from "axios";
import DeletePopup from "../../components/DeletePopup";
import Loader from "../../components/Loader";
import { TableLoader } from "../../components/ContentLoader";
import AddCustomerForm from "./AddCustomerForm";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Edit, Home, Lock, Plus, Search, Trash2, X } from "react-feather";
import AddmembershipCustomerForm from "./AddmembershipCustomerForm"
import dayjs from "dayjs";
import ChangePasswordForm from "../user/ChangePasswordForm";

const CustomerList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [filterVars, setFilterVars] = useState({ searchKey: "" });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [editData, setEditData] = useState(null);
  const [addMembershipModalShow, setAddMembershipModalShow] = useState(false);
  const [currentItemId, setCurrentItemId] = useState(0);
  const [membershipList, setMembershipList] = useState([]);
  const [formOpenPassword, setFormOpenPassword] = useState(false);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchCustpmers = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/customers", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchCustpmers();
  }, [API_TOKEN]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "v1/membership-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        },
      })
      .then((response) => {
        if (response.data.status === "SUCCESS") {
          let itemData = response.data.data;
          setMembershipList(itemData);
        }
      });
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.name.toLowerCase().includes(inputVal) || item.email.toLowerCase().includes(inputVal) || item.phone.toLowerCase().includes(inputVal));
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const deleteConfirm = () => {
    setLoading(true);
    setDeleteModalOpen(false);
    axios.delete(process.env.REACT_APP_API_URL + "v1/customers/" + deleteId, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
        setAllData((prev) => {
          let temp = prev.filter((i) => i.id !== deleteId);
          return temp;
        });
        setDeleteId(0);
      }
      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });
  };

  const statusChange = (e, item) => {
    let status = 0;
    if (e.target.checked) {
      status = 1;
    }
    setLoading(true);
    axios.put(process.env.REACT_APP_API_URL + "v1/customers/" + item?.id, { status: status }, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
        setAllData((prev) => {
          let temp = prev.map((i) => {
            if (i.id === item?.id) {
              return { ...item, status: status };
            }
            return i;
          });
          return temp;
        });
      }
      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    })
      .catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
  }

  const onSubmitAddForm = (data) => {
    setAllData((prev) => {
      return [data].concat(prev);
    });
  }

  const onSubmitEditForm = (data) => {
    setAllData((prev) => {
      let temp = prev.map((i) => {
        if (i.id === editData?.id) {
          return data;
        }
        return i;
      });
      return temp;
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>Customers List</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Customers</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>List</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          <div className="TableFilterHead">
            <div className="DataTableSearch">
              <Search className="SearchIcon" />
              <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            {(auth?.user_type === 2 || auth?.permissions?.indexOf('customers:add') > -1) && <div className="TableFilterBUSec">
              <Button className="TableAddBU" onClick={(e) => { setFormOpen(true); setEditData(null); }}><Add /> Customer</Button>
            </div>}
          </div>

          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell>Customer Id</StyledMainTableCell>
                    <StyledMainTableCell>Name</StyledMainTableCell>
                    <StyledMainTableCell>Email</StyledMainTableCell>
                    <StyledMainTableCell>Phone</StyledMainTableCell>
                    <StyledMainTableCell>Current Membership</StyledMainTableCell>
                    <StyledMainTableCell>Active</StyledMainTableCell>
                    {(auth?.user_type === 2 || auth?.permissions?.indexOf('customers:update') > -1) && <StyledMainTableCell></StyledMainTableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                    return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">{item?.customer_id}</TableCell>
                      <TableCell component="th" scope="row">{item?.name}</TableCell>
                      <TableCell component="th" scope="row">{item?.email}</TableCell>
                      <TableCell component="th" scope="row">{item?.phone}</TableCell>
                      <TableCell component="th" scope="row">
                        {item.current_membership ? item?.current_membership : "-"}
                        <br />
                        {item.membership_expired_date && 'Expired On: ' + dayjs(item?.membership_expired_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell component="th" scope="row">
                        <Switch disabled={!(auth?.user_type === 2 || auth?.permissions?.indexOf('customers:update') > -1)} checked={item?.status === 1 ? true : false} onChange={(e) => statusChange(e, item)} inputProps={{ "aria-label": "controlled" }} />
                      </TableCell>
                      {(auth?.user_type === 2 || auth?.permissions?.indexOf('customers:update') > -1) && <TableCell component="th" scope="row" align="right">
                        <Button onClick={(e) => { setFormOpen(true); setEditData(item); }} className="TableActionBU"><Edit /></Button>
                        <Button onClick={(e) => { setFormOpenPassword(true); setEditData(item); }} className="TableActionBU"><Lock /></Button>
                        <Button onClick={(e) => { setDeleteModalOpen(true); setDeleteId(item?.id); }} className="TableActionBU"><Trash2 /></Button>
                        {membershipList.length > 0 && auth?.subscription?.id > 3 && <Tooltip title="Add Membership">
                          <Button onClick={(e) => { setAddMembershipModalShow(true); setCurrentItemId(item?.id); }} className="TableActionBU"><Plus /></Button>
                        </Tooltip>}
                      </TableCell>}
                    </StyledMainTableRow>);
                  })}
                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={6} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>
                {filteredData.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>

    <Dialog
      open={formOpen}
      onClose={(e) => setFormOpen(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        {editData ? "Update Customer" : "Add Customer"}
        <button onClick={(e) => setFormOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <AddCustomerForm onSubmitAddForm={onSubmitAddForm.bind(this)} onSubmitEditForm={onSubmitEditForm.bind(this)} setFormOpen={setFormOpen.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={editData} />
      </DialogContent>
    </Dialog>

    <DeletePopup open={deleteModalOpen} setOpen={setDeleteModalOpen.bind(this)} confirmAction={deleteConfirm.bind(this)} />
    <Dialog
      open={addMembershipModalShow}
      onClose={(e) => setAddMembershipModalShow(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Add Membership
        <button onClick={(e) => setAddMembershipModalShow(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <AddmembershipCustomerForm id={currentItemId} setAddMembershipModalShow={setAddMembershipModalShow.bind(this)} setAllData={setAllData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={editData} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={formOpenPassword}
      onClose={(e) => setFormOpenPassword(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Change Password
        <button onClick={(e) => setFormOpenPassword(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <ChangePasswordForm setFormOpen={setFormOpenPassword.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} id={editData?.user_id} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>
  );
};

export default withAdminAuth(CustomerList);